export var CountdownFormat;
(function (CountdownFormat) {
    CountdownFormat["DAY_HOUR_MIN_SEC"] = "dd-hh-mm-ss";
    CountdownFormat["HOUR_MIN_SEC"] = "hh-mm-ss";
    CountdownFormat["MIN_SEC"] = "mm-ss";
    CountdownFormat["SEC"] = "ss";
    CountdownFormat["DAY"] = "dd";
    CountdownFormat["DAY_HOUR"] = "dd-hh";
    CountdownFormat["DAY_HOUR_MIN"] = "dd-hh-mm";
})(CountdownFormat || (CountdownFormat = {}));
export var CountdownUnite;
(function (CountdownUnite) {
    CountdownUnite[CountdownUnite["DAY"] = 0] = "DAY";
    CountdownUnite[CountdownUnite["HOUR"] = 1] = "HOUR";
    CountdownUnite[CountdownUnite["MIN"] = 2] = "MIN";
    CountdownUnite[CountdownUnite["SEC"] = 3] = "SEC";
})(CountdownUnite || (CountdownUnite = {}));
export var getFormatWidth = function (format) {
    switch (format) {
        case CountdownFormat.HOUR_MIN_SEC:
        case CountdownFormat.DAY_HOUR_MIN:
            return '60%';
        case CountdownFormat.MIN_SEC:
        case CountdownFormat.DAY_HOUR:
            return '40%';
        case CountdownFormat.SEC:
        case CountdownFormat.DAY:
            return '20%';
        default:
            return '80%';
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ291bnRkb3duRW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvY291bnRkb3duL0NvdW50ZG93bkVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksZUFRWDtBQVJELFdBQVksZUFBZTtJQUN6QixtREFBZ0MsQ0FBQTtJQUNoQyw0Q0FBeUIsQ0FBQTtJQUN6QixvQ0FBaUIsQ0FBQTtJQUNqQiw2QkFBVSxDQUFBO0lBQ1YsNkJBQVUsQ0FBQTtJQUNWLHFDQUFrQixDQUFBO0lBQ2xCLDRDQUF5QixDQUFBO0FBQzNCLENBQUMsRUFSVyxlQUFlLEtBQWYsZUFBZSxRQVExQjtBQUNELE1BQU0sQ0FBTixJQUFZLGNBS1g7QUFMRCxXQUFZLGNBQWM7SUFDeEIsaURBQUcsQ0FBQTtJQUNILG1EQUFJLENBQUE7SUFDSixpREFBRyxDQUFBO0lBQ0gsaURBQUcsQ0FBQTtBQUNMLENBQUMsRUFMVyxjQUFjLEtBQWQsY0FBYyxRQUt6QjtBQUVELE1BQU0sQ0FBQyxJQUFNLGNBQWMsR0FBRyxVQUFDLE1BQXVCO0lBQ3BELFFBQVEsTUFBTSxFQUFFO1FBQ2QsS0FBSyxlQUFlLENBQUMsWUFBWSxDQUFDO1FBQ2xDLEtBQUssZUFBZSxDQUFDLFlBQVk7WUFDL0IsT0FBTyxLQUFLLENBQUE7UUFDZCxLQUFLLGVBQWUsQ0FBQyxPQUFPLENBQUM7UUFDN0IsS0FBSyxlQUFlLENBQUMsUUFBUTtZQUMzQixPQUFPLEtBQUssQ0FBQTtRQUNkLEtBQUssZUFBZSxDQUFDLEdBQUcsQ0FBQztRQUN6QixLQUFLLGVBQWUsQ0FBQyxHQUFHO1lBQ3RCLE9BQU8sS0FBSyxDQUFBO1FBQ2Q7WUFDRSxPQUFPLEtBQUssQ0FBQTtLQUNmO0FBQ0gsQ0FBQyxDQUFBIn0=